'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _H = require('UIComponents/elements/headings/H3');

var _H2 = _interopRequireDefault(_H);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _sideBar = require('../../../constants/sideBar');

var _QueryParamsContainer2 = require('../../../globals/QueryParamsContainer');

var _QueryParamsContainer3 = _interopRequireDefault(_QueryParamsContainer2);

var _Logger = require('../../../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _localImages = require('../../../utils/localImages');

var _localImages2 = _interopRequireDefault(_localImages);

var _CustomSidebar = require('./CustomSidebar.styles');

var _Sidebar = require('../Sidebar.styles');

var _CustomSidebarOptions = require('./CustomSidebarOptions');

var _CustomSidebarOptions2 = _interopRequireDefault(_CustomSidebarOptions);

var _DefaultSidebar = require('../default/DefaultSidebar');

var _DefaultSidebar2 = _interopRequireDefault(_DefaultSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOG = _Logger2.default.getLogger('CustomSidebar');

var CustomSidebar = function (_React$PureComponent) {
  _inherits(CustomSidebar, _React$PureComponent);

  function CustomSidebar() {
    _classCallCheck(this, CustomSidebar);

    return _possibleConstructorReturn(this, (CustomSidebar.__proto__ || Object.getPrototypeOf(CustomSidebar)).apply(this, arguments));
  }

  _createClass(CustomSidebar, [{
    key: 'getCustomOptions',
    value: function getCustomOptions(sidebarType) {
      var querySidebarOptions = _CustomSidebarOptions2.default[sidebarType];
      return querySidebarOptions || _sideBar.sidebarMapping[sidebarType];
    }
  }, {
    key: 'render',
    value: function render() {
      var sidebarOptions = this.getCustomOptions(this.props.sidebarType);

      if (!sidebarOptions) {
        // render default if given sidebar option doesn't exist
        LOG.warn("Custom sidebar option doesn't exist - using default");
        return _react2.default.createElement(_DefaultSidebar2.default, null);
      }

      var imageName = sidebarOptions.imageName,
          imageAlt = sidebarOptions.imageAlt,
          illustration = sidebarOptions.illustration,
          sidebarMessage = sidebarOptions.sidebarMessage,
          isInternationalized = sidebarOptions.isInternationalized;

      var centerText = !imageName;

      var _QueryParamsContainer = _QueryParamsContainer3.default.getJS(),
          trialId = _QueryParamsContainer.trialId,
          trialLength = _QueryParamsContainer.trialLength;

      var options = trialId ? { trialLength: trialLength || 14, centerText: centerText } : { centerText: centerText };

      return _react2.default.createElement(
        _Sidebar.SidebarWrapper,
        null,
        _react2.default.createElement(
          _CustomSidebar.Container,
          null,
          illustration && _react2.default.createElement(
            _CustomSidebar.IllustrationContainer,
            null,
            _react2.default.createElement(_UIIllustration2.default, {
              name: illustration,
              width: '100%',
              objectFit: 'fill',
              bordered: false
            })
          ),
          _react2.default.createElement(
            _H2.default,
            null,
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: sidebarMessage, options: options })
          ),
          imageName && _react2.default.createElement(_CustomSidebar.Image, {
            alt: imageAlt,
            src: !isInternationalized ? _localImages2.default.get(imageName) : _localImages2.default.getInternationalized(imageName, (0, _getLang2.default)()),
            responsive: false
          })
        )
      );
    }
  }]);

  return CustomSidebar;
}(_react2.default.PureComponent);

CustomSidebar.propTypes = {
  sidebarType: _propTypes2.default.string.isRequired
};
exports.default = CustomSidebar;
module.exports = exports['default'];